"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sondrio": {
    "1115cfe0": [{
      "hkey": "8781a28f",
      "slug": "garibaldi",
      "name": "Garibaldi",
      "primary": true,
      "skipSearch": false
    }],
    "2a90bb9c": [{
      "hkey": "d1fa0810",
      "slug": "viale-milano",
      "name": "Viale Milano",
      "primary": true,
      "skipSearch": false
    }],
    "2dbf4d69": [{
      "hkey": "c1767444",
      "slug": "bertacchi",
      "name": "Bertacchi",
      "primary": true,
      "skipSearch": false
    }],
    "5797f3ac": [{
      "hkey": "0b5c729a",
      "slug": "ospedale",
      "name": "Ospedale",
      "primary": false,
      "skipSearch": false
    }],
    "62eab8a7": [{
      "hkey": "0b5c729a",
      "slug": "ospedale",
      "name": "Ospedale",
      "primary": true,
      "skipSearch": false
    }],
    "7aa4b918": [{
      "hkey": "651c359e",
      "slug": "triasso-sassella",
      "name": "Triasso-Sassella",
      "primary": true,
      "skipSearch": false
    }],
    "b701517e": [{
      "hkey": "89bb0373",
      "slug": "de-simoni",
      "name": "De Simoni",
      "primary": true,
      "skipSearch": false
    }],
    "c90a1d14": [{
      "hkey": "8781a28f",
      "slug": "garibaldi",
      "name": "Garibaldi",
      "primary": false,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "8781a28f",
      "slug": "garibaldi",
      "name": "Garibaldi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sondrio"
    }],
    "centro-zona-de-simoni": [{
      "hkey": "89bb0373",
      "slug": "de-simoni",
      "name": "De Simoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "centro-zona-garibaldi": [{
      "hkey": "8781a28f",
      "slug": "garibaldi",
      "name": "Garibaldi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "centro-zona-ospedale": [{
      "hkey": "0b5c729a",
      "slug": "ospedale",
      "name": "Ospedale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f49cc673": [{
      "hkey": "66b365dd",
      "slug": "mossini-ronchi-sant-anna",
      "name": "Mossini-Ronchi-Sant'Anna",
      "primary": true,
      "skipSearch": false
    }],
    "mossini-sant-anna": [{
      "hkey": "66b365dd",
      "slug": "mossini-ronchi-sant-anna",
      "name": "Mossini-Ronchi-Sant'Anna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "semic-zona-p-le-bertacchi": [{
      "hkey": "c1767444",
      "slug": "bertacchi",
      "name": "Bertacchi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "semic-zona-viale-milano": [{
      "hkey": "d1fa0810",
      "slug": "viale-milano",
      "name": "Viale Milano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "semic-zona-via-lusardi": [{
      "hkey": "0b5c729a",
      "slug": "ospedale",
      "name": "Ospedale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sondrio"
    }],
    "triasso": [{
      "hkey": "651c359e",
      "slug": "triasso-sassella",
      "name": "Triasso-Sassella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;